module.exports = __webpack_public_path__ + "static/media/10.1c4f403d.png";